import { useAuthStore } from '@/store/auth';

export const ROLE_SCOPE_QUERY_KEY_PREFIX: 'roleScope' = 'roleScope';

export type UnscopedQueryKey = ReadonlyArray<unknown>;
export type RoleScopedQueryKey = ReadonlyArray<unknown>;

export function buildRoleScopedQueryKey(
    activeRoleAssignmentId: number | null,
    baseQueryKey: UnscopedQueryKey
): RoleScopedQueryKey {
    return [ROLE_SCOPE_QUERY_KEY_PREFIX, activeRoleAssignmentId, ...baseQueryKey];
}

export function useRoleScopedQueryKey(baseQueryKey: UnscopedQueryKey): RoleScopedQueryKey {
    const activeRoleAssignmentId: number | null = useAuthStore(
        (state) => state.activeRoleAssignmentId
    );
    return buildRoleScopedQueryKey(activeRoleAssignmentId, baseQueryKey);
}
